import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask4000To4099Service {

  constructor() { }
}
